'use client';

import { Carousel } from '@publishing/modules/carousel/Carousel';
import { Autoplay, EffectFade } from 'swiper';
import 'swiper/css/effect-fade';
import type { ResponsivePair } from '@publishing/helpers/responsive';
import s from './HeaderSection.module.scss';

type HeaderImageSrcPair = ResponsivePair<string>;

interface HeaderBgSliderProps {
  images: HeaderImageSrcPair[];
}

export default function HeaderBgSlider({ images }: HeaderBgSliderProps) {
  return (
    <div className={s.header_bg_slider} aria-hidden="true">
      <Carousel
        modules={[Autoplay, EffectFade]}
        slidesPerView={1}
        speed={1000}
        gap={0}
        loop
        effect="fade"
        fadeEffect={{ crossFade: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        allowTouchMove={false}
        className={s.header_bg_carousel}
      >
        {images.map(([src, mobileSrc = src], index) => (
          <picture key={`${src}-${index}`} className={s.header_bg_picture}>
            <source media="(max-width: 1024px)" srcSet={mobileSrc} />
            <img src={src} alt="" className={s.header_bg_img} />
          </picture>
        ))}
      </Carousel>
    </div>
  );
}
